<template>
  <!-- Ayuda -->
  <b-nav-item-dropdown class="help-nav-ddl" right no-caret>
    <!-- Using 'button-content' slot -->
    <template v-slot:button-content>
      <span class="avatar avatar-sm rounded-circle">
        <em class="fal fa-question-circle iconNav1" />
      </span>
    </template>

    <b-dropdown-item href="#">
      <i class="fas fa-book"></i>
      <span>Manual</span>
    </b-dropdown-item>

    <div class="dropdown-divider"></div>

    <b-dropdown-item href="#">
      <i class="fas fa-video"></i>
      <span>Videos</span>
    </b-dropdown-item>

    <b-dropdown-item href="#">
      <span>Mesa de Apoyo</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
  <!-- Fin Ayuda -->
</template>

<script>
export default {
  name: 'HelpNav',
}
</script>

<style scoped>
.help-nav-ddl >>> .dropdown-item {
  padding: 4px 16px;
}

.help-nav-ddl >>> i {
  color: #ff7058;
  margin-right: 0.5rem;
}

.help-nav-ddl >>> .dropdown-item span {
  color: #36484b;
  font-size: 16px;
  font-weight: bold;
}

.div-help {
  margin-left: -10px;
  color: #ff7058;
}
.help-text {
  margin-left: -10px;
}
.help-information {
  margin-left: -10px !important;
}

@media screen and (max-width: 767px) {
  .avatar {
    width: 33px;
    height: 33px;
    font-size: 16px;
  }
}
</style>
